export const PRIMARY_BADGE_COLORS = [
  'teal',
  'blue',
  'red',
  'orange',
  'purple',
  'light',
  'dark',
]

export const SECONDARY_BADGE_COLORS = [
  'green',
  'blue',
  'pink',
  'orange',
  'yellow',
]
